import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { Experiments, IPageWillMountHandler } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol, ExperimentsSymbol } from '@wix/thunderbolt-symbols'
import type { BuilderContextProvidersPageConfig, ContextProviderLoader } from './types'
import { name, ContextProviderLoaderSymbol } from './symbols'

export const BuilderContextProvidersPageWillMountHandler = withDependencies(
	[named(PageFeatureConfigSymbol, name), ContextProviderLoaderSymbol, ExperimentsSymbol],
	(
		pageFeatureConfig: BuilderContextProvidersPageConfig,
		contextProviderLoader: ContextProviderLoader,
		experiments: Experiments
	): IPageWillMountHandler => {
		return {
			name: 'builderContextProvidersLoader',
			pageWillMount: async () => {
				if (!experiments['specs.thunderbolt.contextProviders']) {
					return
				}

				await Promise.all(
					Object.keys(pageFeatureConfig.compIdToContextsMap).map((compId) =>
						contextProviderLoader.retrieveContextProviders(compId)
					)
				)
			},
		}
	}
)
